import { render, staticRenderFns } from "./JobsTreeDepartments.vue?vue&type=template&id=3b083adc"
import script from "./JobsTreeDepartments.vue?vue&type=script&lang=js"
export * from "./JobsTreeDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports